﻿let FAQData: any = null;
let FAQDataRaw: any = null;
let languageId: number = 0;

namespace WebPortal.Default {
    export class FAQHandler {
        langDe = 2;
        langEn = 4;
        constructor() { this.init(); }

        private init(): void {
            $('#nav_faq').off().on('click', () => {
                if (!FAQData) {
                    Show_Status_Message({ title: "FAQ Preparation", message: "Loading FAQ Data", progress: true });
                    WebPortalHubObj.server.doFAQListRequest($("#hdf_se_request_param").val());
                   
                    if ($("#hdf_settings").val()) {
                        let UserSettings = JSON.parse($("#hdf_settings").val());
                        languageId = UserSettings.Language_ID;
                    }            }
                setTimeout(() => { this.resize(); }, 500);
            });

            $("#bt_change_faq_language_en").off().on("click", () => {
                if (languageId !== this.langEn) {
                    languageId = this.langEn;
                    this.PrepareFAQArea(FAQDataRaw)
                }
            });

            $("#bt_change_faq_language_de").off().on("click", () => {
                if (languageId !== this.langDe) {
                    languageId = this.langDe;
                    this.PrepareFAQArea(FAQDataRaw)
                }
            });

            // filter function
            $("#tb_faq_filter").off().on("keyup", (e: JQueryEventObject) => {
                let searchstring: string = $(e.currentTarget).val().toLowerCase();
                console.info();
                Accordion.FilterAccordion(searchstring, "faq");
            });

            // Code für das Anzeige und verschwinden lassen des X bei Inputfeldern
            $('.has-clear-faq input[type="text"]').on("input propertychange", (e: JQueryEventObject) => {                
                let visible: boolean = Boolean($(e.currentTarget).val());
                $(e.currentTarget).siblings('.clear-faq').toggleClass('hidden', !visible);
            }).trigger('propertychange');

            $('.clear-faq').off().on("click", (e: JQueryEventObject) => {                
                Accordion.FilterAccordion("", "faq");
                $(e.currentTarget).siblings('input[type="text"]').val('')
                    .trigger('propertychange').focus();
            });            
        }

        public PrepareFAQArea(_FAQData: any): void {
            FAQDataRaw = _FAQData;
            
            if (!!_FAQData) {
                FAQData = _FAQData;
                $("#ac_faq").empty();
                for (var itr = 0; itr < _FAQData.length - 1; itr++) {
                    let FAQObj = _FAQData[itr];
                    if (FAQObj.QuestionDe && FAQObj.AnswerDe || FAQObj.QuestionEn && FAQObj.AnswerEn) {
                        if (languageId === this.langDe) {
                            $("#ac_faq").append(Accordion.GetAccordionElement(itr, FAQObj.QuestionDe, FAQObj.AnswerDe, "faq"));
                        }
                        else {
                            $("#ac_faq").append(Accordion.GetAccordionElement(itr, FAQObj.QuestionEn, FAQObj.AnswerEn, "faq"));
                        }
                    }
                }
                Close_Status_Message();
            }
            this.resize();
        }

        public resize(): void {
            let MaxDivHeight = $(window).height() - (12 + $('#pn_default_navigation').height() + $('#tb_faq_filter').height() + 38 + 65);
            if ($('#ac_faq').height() > 300) {
                $('#ac_faq').height(MaxDivHeight.toString() + "px");
            } else {
                $('#ac_faq').height("100%");
            }
        }

    }
}
